import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import FileAttachments from '../components/FileAttachments';
import InformesMensualesSection from '../components/InformesMensualesSection';
import { Sparkles, Plus, XCircle, CheckCircle2, ChevronDown, ChevronUp, Paperclip, Pencil, Trash2, AlertCircle } from 'lucide-react';
import { ModalEliminarRegistro, esAdmin } from '../components/RegistroAcciones';

function ModalLimpieza({ onClose, onGuardado }) {
  const today = new Date().toISOString().split('T')[0];
  const [form, setForm] = useState({
    fecha: today, zona: 'Zona almacén y manipulación', tipo_limpieza: 'diaria',
    producto_usado: '', operario_nombre: '', estado: 'completado',
    observaciones: '', vb_tecnico: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [savedId, setSavedId] = useState(null);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const guardar = async () => {
    if (!form.fecha || !form.zona) { setError('Fecha y zona son obligatorias'); return; }
    setLoading(true);
    try {
      const res = await api.post('/registros/limpieza', form);
      setSavedId(res.data.id);
    } catch (e) { setError(e.response?.data?.error || 'Error'); }
    finally { setLoading(false); }
  };

  return (
    <div className="modal-overlay">
      <div className="modal modal-lg">
        <div className="modal-header">
          <h2 style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Sparkles size={18} color="var(--color-primary)" /> Nuevo Registro de Limpieza
          </h2>
          <button className="btn btn-ghost btn-icon" onClick={onClose}><XCircle size={18} /></button>
        </div>
        <div className="modal-body">
          {error && <div className="alert alert-danger">{error}</div>}
          {savedId && (
            <div className="alert alert-success">
              <CheckCircle2 size={16} /> Registro guardado. Ahora puedes adjuntar la hoja firmada.
            </div>
          )}

          <div className="form-grid">
            <div className="form-group"><label className="form-label">Fecha <span className="required">*</span></label>
              <input type="date" className="form-control" value={form.fecha} onChange={e => set('fecha', e.target.value)} disabled={!!savedId} /></div>
            <div className="form-group">
              <label className="form-label">Tipo de limpieza</label>
              <select className="form-control" value={form.tipo_limpieza} onChange={e => set('tipo_limpieza', e.target.value)} disabled={!!savedId}>
                <option value="diaria">Diaria</option><option value="semanal">Semanal</option>
                <option value="mensual">Mensual</option><option value="extraordinaria">Extraordinaria</option>
              </select>
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Zona limpiada <span className="required">*</span></label>
            <select className="form-control" value={form.zona} onChange={e => set('zona', e.target.value)} disabled={!!savedId}>
              <option>Zona almacén y manipulación</option><option>Baños</option>
              <option>Zona comedor</option><option>Despacho</option>
              <option>Zona recepción</option><option>Todas las zonas</option>
            </select>
          </div>
          <div className="form-group"><label className="form-label">Producto usado</label>
            <input className="form-control" value={form.producto_usado} onChange={e => set('producto_usado', e.target.value)} disabled={!!savedId} /></div>
          <div className="form-grid">
            <div className="form-group"><label className="form-label">Operario</label>
              <input className="form-control" value={form.operario_nombre} onChange={e => set('operario_nombre', e.target.value)} disabled={!!savedId} /></div>
            <div className="form-group">
              <label className="form-label">Estado</label>
              <select className="form-control" value={form.estado} onChange={e => set('estado', e.target.value)} disabled={!!savedId}>
                <option value="completado">Completado</option>
                <option value="pendiente">Pendiente</option>
                <option value="incidencia">Incidencia</option>
              </select>
            </div>
          </div>
          <div className="form-group"><label className="form-label">Observaciones</label>
            <textarea className="form-control" rows={3} value={form.observaciones} onChange={e => set('observaciones', e.target.value)} disabled={!!savedId} /></div>
          <div className="form-group"><label className="form-label">Vº Bº Técnico Responsable</label>
            <input className="form-control" value={form.vb_tecnico} onChange={e => set('vb_tecnico', e.target.value)} disabled={!!savedId} /></div>

          <FileAttachments
            seccion="limpieza" entidadTipo="limpieza" entidadId={savedId}
            label="Adjuntar hoja de limpieza firmada (PDF/imagen)"
          />
        </div>
        <div className="modal-footer">
          {!savedId ? (
            <>
              <button className="btn btn-outline" onClick={onClose}>Cancelar</button>
              <button className="btn btn-primary" onClick={guardar} disabled={loading}>
                {loading ? <div className="spinner" style={{ width: 16, height: 16 }} /> : <CheckCircle2 size={16} />} Guardar
              </button>
            </>
          ) : (
            <>
              <button className="btn btn-outline" onClick={onClose}>Cerrar sin más archivos</button>
              <button className="btn btn-primary" onClick={onGuardado}><CheckCircle2 size={16} /> Finalizar</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}


// ═══════════════════════════════════════════════════════════════
// MODAL: Editar registro de limpieza (admin + contraseña)
// ═══════════════════════════════════════════════════════════════
function ModalEditarLimpieza({ registro, onClose, onActualizado }) {
  const [form, setForm] = useState({
    fecha: registro.fecha,
    zona: registro.zona || 'Zona almacén y manipulación',
    tipo_limpieza: registro.tipo_limpieza || 'diaria',
    producto_usado: registro.producto_usado || '',
    operario_nombre: registro.operario_nombre || '',
    estado: registro.estado || 'completado',
    observaciones: registro.observaciones || '',
    vb_tecnico: registro.vb_tecnico || ''
  });
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleGuardar = async () => {
    if (!password) { setError('Debes introducir tu contraseña'); return; }
    setLoading(true); setError('');
    try {
      await api.put(`/registros/limpieza/${registro.id}`, { ...form, password });
      onActualizado();
    } catch (err) {
      setError(err.response?.data?.error || 'Error al actualizar');
    } finally { setLoading(false); }
  };

  return (
    <div className="modal-overlay">
      <div className="modal modal-lg">
        <div className="modal-header">
          <h2 style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Pencil size={20} color="#3b82f6" /> Editar Registro de Limpieza
          </h2>
          <button className="btn btn-ghost btn-icon" onClick={onClose}><XCircle size={18} /></button>
        </div>
        <div className="modal-body">
          <div className="alert alert-warning" style={{ fontSize: '0.85rem' }}>
            <AlertCircle size={16} /> <strong>Acción restringida:</strong> Solo administradores. Se requiere contraseña.
          </div>

          <div className="form-grid">
            <div className="form-group"><label className="form-label">Fecha</label>
              <input type="date" className="form-control" value={form.fecha} onChange={e => set('fecha', e.target.value)} /></div>
            <div className="form-group">
              <label className="form-label">Tipo de limpieza</label>
              <select className="form-control" value={form.tipo_limpieza} onChange={e => set('tipo_limpieza', e.target.value)}>
                <option value="diaria">Diaria</option><option value="semanal">Semanal</option>
                <option value="mensual">Mensual</option><option value="extraordinaria">Extraordinaria</option>
              </select>
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Zona limpiada</label>
            <select className="form-control" value={form.zona} onChange={e => set('zona', e.target.value)}>
              <option>Zona almacén y manipulación</option><option>Baños</option>
              <option>Zona comedor</option><option>Despacho</option>
              <option>Zona recepción</option><option>Todas las zonas</option>
            </select>
          </div>
          <div className="form-group"><label className="form-label">Producto usado</label>
            <input className="form-control" value={form.producto_usado} onChange={e => set('producto_usado', e.target.value)} /></div>
          <div className="form-grid">
            <div className="form-group"><label className="form-label">Operario</label>
              <input className="form-control" value={form.operario_nombre} onChange={e => set('operario_nombre', e.target.value)} /></div>
            <div className="form-group">
              <label className="form-label">Estado</label>
              <select className="form-control" value={form.estado} onChange={e => set('estado', e.target.value)}>
                <option value="completado">Completado</option>
                <option value="pendiente">Pendiente</option>
                <option value="incidencia">Incidencia</option>
              </select>
            </div>
          </div>
          <div className="form-group"><label className="form-label">Observaciones</label>
            <textarea className="form-control" rows={2} value={form.observaciones} onChange={e => set('observaciones', e.target.value)} /></div>
          <div className="form-group"><label className="form-label">Vº Bº Técnico Responsable</label>
            <input className="form-control" value={form.vb_tecnico} onChange={e => set('vb_tecnico', e.target.value)} /></div>

          <div className="form-group" style={{ marginTop: 16, padding: 12, background: '#fef3c7', borderRadius: 8, borderLeft: '4px solid #f59e0b' }}>
            <label className="form-label" style={{ color: '#92400e', fontWeight: 600 }}>🔐 Confirma con tu contraseña</label>
            <input type="password" className="form-control" value={password} onChange={e => setPassword(e.target.value)} placeholder="Tu contraseña actual" />
          </div>

          {error && <div className="alert alert-danger">{error}</div>}
        </div>
        <div className="modal-footer">
          <button className="btn btn-outline" onClick={onClose}>Cancelar</button>
          <button className="btn btn-primary" onClick={handleGuardar} disabled={loading || !password}>
            {loading ? <div className="spinner" style={{ width: 16, height: 16 }} /> : <CheckCircle2 size={16} />}
            Guardar cambios
          </button>
        </div>
      </div>
    </div>
  );
}

function FilaLimpieza({ r, isAdmin, onEditar, onEliminar }) {
  const [expanded, setExpanded] = useState(false);
  const estadoColor = { completado: 'var(--color-success)', pendiente: 'var(--color-warning)', incidencia: 'var(--color-danger)' };

  return (
    <>
      <tr>
        <td>{new Date(r.fecha).toLocaleDateString('es-ES')}</td>
        <td style={{ fontWeight: 500 }}>{r.zona}</td>
        <td style={{ fontSize: '0.82rem', textTransform: 'capitalize' }}>{r.tipo_limpieza}</td>
        <td style={{ fontSize: '0.82rem' }}>{r.producto_usado || '—'}</td>
        <td style={{ fontSize: '0.82rem' }}>{r.operario_nombre}</td>
        <td><span style={{ color: estadoColor[r.estado], fontSize: '0.8rem', fontWeight: 600 }}>● {r.estado}</span></td>
        <td style={{ fontSize: '0.82rem', color: 'var(--color-text-3)' }}>{r.vb_tecnico || '—'}</td>
        <td>
          <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <FileAttachments seccion="limpieza" entidadTipo="limpieza" entidadId={r.id} compact />
            <button className="btn btn-ghost btn-icon btn-sm" onClick={() => setExpanded(!expanded)}>
              {expanded ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
            </button>
            {isAdmin && (
              <>
                <button className="btn btn-ghost btn-icon btn-sm" onClick={() => onEditar(r)} title="Editar (admin)" style={{ color: '#3b82f6' }}>
                  <Pencil size={13} />
                </button>
                <button className="btn btn-ghost btn-icon btn-sm" onClick={() => onEliminar(r)} title="Eliminar (admin)" style={{ color: 'var(--color-danger)' }}>
                  <Trash2 size={13} />
                </button>
              </>
            )}
          </div>
        </td>
      </tr>
      {expanded && (
        <tr>
          <td colSpan={8} style={{ padding: '0 14px 14px', background: 'var(--color-gray-1)' }}>
            <FileAttachments seccion="limpieza" entidadTipo="limpieza" entidadId={r.id} label="Subir hoja de limpieza firmada" />
          </td>
        </tr>
      )}
    </>
  );
}

export default function LimpiezaPage() {
  const [registros, setRegistros] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editarRegistro, setEditarRegistro] = useState(null);
  const [eliminarRegistro, setEliminarRegistro] = useState(null);
  const [success, setSuccess] = useState('');
  const [filtros, setFiltros] = useState({ desde: '', hasta: '' });
  const isAdmin = esAdmin();

  const load = () => {
    setLoading(true);
    api.get('/registros/limpieza', { params: filtros }).then(r => setRegistros(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
        <div>
          <h1 style={{ display: 'flex', alignItems: 'center', gap: 10 }}><Sparkles size={24} color="var(--color-primary)" />Registro de Limpieza</h1>
          <p>{registros.length} registros · Adjunta las hojas firmadas a cada entrada</p>
        </div>
        <button className="btn btn-primary" onClick={() => setModal(true)}><Plus size={16} /> Nuevo Registro</button>
      </div>

      {success && <div className="alert alert-success" style={{ marginBottom: 16 }}><CheckCircle2 size={16} /> {success}</div>}

      {/* Sección de Informes Mensuales (reutilizable) */}
      <InformesMensualesSection tipo="limpieza" />

      <div className="card" style={{ marginBottom: 16, padding: '14px 20px' }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'flex-end' }}>
          <div className="form-group" style={{ margin: 0 }}><label className="form-label">Desde</label>
            <input type="date" className="form-control" value={filtros.desde} onChange={e => setFiltros(f => ({ ...f, desde: e.target.value }))} /></div>
          <div className="form-group" style={{ margin: 0 }}><label className="form-label">Hasta</label>
            <input type="date" className="form-control" value={filtros.hasta} onChange={e => setFiltros(f => ({ ...f, hasta: e.target.value }))} /></div>
          <button className="btn btn-outline" onClick={load}>Filtrar</button>
        </div>
      </div>

      <div className="card">
        {loading ? <div className="loading-overlay"><div className="spinner" /></div> :
          registros.length === 0 ? (
            <div className="empty-state"><Sparkles size={48} /><h3>Sin registros de limpieza</h3></div>
          ) : (
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Fecha</th><th>Zona</th><th>Tipo</th><th>Producto</th>
                    <th>Operario</th><th>Estado</th><th>Vº Bº</th>
                    <th><Paperclip size={13} /></th>
                  </tr>
                </thead>
                <tbody>
                  {registros.map(r => <FilaLimpieza key={r.id} r={r} isAdmin={isAdmin} onEditar={setEditarRegistro} onEliminar={setEliminarRegistro} />)}
                </tbody>
              </table>
            </div>
          )
        }
      </div>
      {modal && <ModalLimpieza onClose={() => setModal(false)} onGuardado={() => { setModal(false); load(); }} />}
      {editarRegistro && <ModalEditarLimpieza registro={editarRegistro} onClose={() => setEditarRegistro(null)} 
        onActualizado={() => { setEditarRegistro(null); load(); setSuccess('Registro actualizado'); setTimeout(() => setSuccess(''), 3000); }} />}
      {eliminarRegistro && <ModalEliminarRegistro 
        endpoint={`/registros/limpieza/${eliminarRegistro.id}`}
        descripcion={`${new Date(eliminarRegistro.fecha).toLocaleDateString('es-ES')} · ${eliminarRegistro.zona} · ${eliminarRegistro.tipo_limpieza || ''}`}
        onClose={() => setEliminarRegistro(null)} 
        onEliminado={() => { setEliminarRegistro(null); load(); setSuccess('Registro eliminado'); setTimeout(() => setSuccess(''), 3000); }} />}
    </div>
  );
}
